import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { IndividualAcreagesDto, LandTitleDto, LessorInfoDto, MeasureDto, TerrainDto } from '@cradua/data';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-individual-acreages-table',
  templateUrl: './individual-acreages-table.component.html',
  styleUrls: ['./individual-acreages-table.component.scss']
})
export class IndividualAcreagesTableComponent implements OnChanges {
  @Input() individualAcreages: IndividualAcreagesDto[];
  @Input() selectedLandTitle: LandTitleDto;
  @Input() selectedLessorInfo: LessorInfoDto;
  @Input() terrains: TerrainDto[];
  @Input() measures: MeasureDto[];

  @Output() emitEdit = new EventEmitter<any>();
  individualAcreagesArrayForm: FormGroup;
  selectedIndex = null;
  filteredDelete = [];
  assignedArea: string | number = 0;
  unAssignedArea;
  RecTotalArea: string | number;
  listView = false;
  gridView = true;

  constructor(private fb: FormBuilder) { }

  ngOnChanges(): void {

    this.RecTotalArea = this.selectedLandTitle?.RecTotalArea?.toFixed(6);

    this.individualAcreagesArrayForm = this.fb.group({IndividualAcreages: this.fb.array([])});
    if(this.individualAcreages != null && this.individualAcreages.length) {
      this.filterIndividualAcreages(this.selectedLessorInfo);
    }

    if(this.individualAcreages != null && this.individualAcreages.length) {
      const foundAcreages = this.individualAcreages
      .filter(acr => acr.LessorsId === this.selectedLessorInfo.id)
      .map((item) => item.NetArea);

      this.assignedArea =  foundAcreages?.length ? foundAcreages
      .reduce((prev, next) => prev + next).toFixed(6) : 0;

      this.unAssignedArea = (this.selectedLandTitle.RecTotalArea - +this.assignedArea).toFixed(6);

    }
  }

  filterIndividualAcreages(selectedLessorInfo: LessorInfoDto) {
    const filteredIndividualAcreages = this.individualAcreages.filter(item => item.AddressBookId === selectedLessorInfo.AddressBookId && item.LessorsId === selectedLessorInfo.id);
    if(filteredIndividualAcreages != null && filteredIndividualAcreages.length) {
      this.setIndividualAcreages(filteredIndividualAcreages);
    }
  }


  get individualAcreagesFormArray() {
    return this.individualAcreagesArrayForm.get('IndividualAcreages') as FormArray;
  }

  onList() {
    this.listView = true;
    this.gridView = false;
  }

  onGrid() {
    this.gridView = true;
    this.listView = false;
  }

  onEdit(value, index) {
    this.selectedIndex = index;
    value['index'] = index;
    this.emitEdit.emit(value);
  }


  setIndividualAcreages(individualAcreages: IndividualAcreagesDto[]) {
    individualAcreages.forEach(individual => {
      this.individualAcreagesFormArray.push(this.fb.group({
        TerrainId: individual.TerrainId,
        NetArea: individual.NetArea,
        MeasureId: individual.MeasureId,
        Remarks: individual.Remarks,
        AddressBookId: individual.AddressBookId,
        LandTitleId: individual.LandTitleId,
        LessorsId: individual.LessorsId,
        id: individual.id

      }));
    });
  }


  addIndividualAcreages(individual: IndividualAcreagesDto) {
  this.individualAcreagesFormArray.insert(0, this.fb.group({
    TerrainId: individual.TerrainId,
        NetArea: individual.NetArea,
        MeasureId: individual.MeasureId,
        Remarks: individual.Remarks,
      AddressBookId: this.selectedLessorInfo.AddressBookId,
      LessorsId: this.selectedLessorInfo.id,
      LandTitleId: this.selectedLessorInfo.LandTitleId,
      }));
  }


  onDelete(value, index: number) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        // this.dispatchDelete.emit(id);
        this.individualAcreagesFormArray.removeAt(index);
        if(value.id != null) {
          this.filteredDelete.push(value.id);
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  getTerrainName(id: string) {
    const found = this.terrains.find(item => item.id === id);
    return found ? found.TerrainName : '';
  }

  getMeasureName(id: string) {
    const found = this.measures.find(item => item.id === id);
    return found ? found.MeasureName : '';
  }

}
